export default [
	{
		start: 0.05,
		end: 3,
		text: 'Je vous ai déjà dit que vous aviez de supers goûts en déco ?'
	}
]
